export default "__VITE_ASSET__DChLWPNl__"